"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ApiContextProvider = void 0;

var _react = _interopRequireWildcard(require("react"));

var _api = _interopRequireDefault(require("@lt/api"));

var _apiContext = require("./apiContext");

var _constructorContext = require("../constructorContext");

var _api2 = require("../../utils/api");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var ApiContextProvider = function ApiContextProvider(_ref) {
  var children = _ref.children,
      apiDomain = _ref.apiDomain;
  var constructorKey = (0, _constructorContext.useGetPartnerKey)();
  var apiKey = _api2.safetyPartnerKey || constructorKey;
  var apiBaseUrl = apiDomain || _api2.baseUrl || 'https://api.level.travel';
  var state = (0, _react.useMemo)(function () {
    if (!apiKey) {
      return {
        api: undefined
      };
    }

    var client = new _api["default"]({
      key: apiKey,
      baseURL: apiBaseUrl
    });
    return {
      api: client
    };
  }, [apiKey, apiBaseUrl]);

  if (!apiKey) {
    console.log('Не найден ключ партнера');
    return null;
  }

  return /*#__PURE__*/_react["default"].createElement(_apiContext.apiContext.Provider, {
    value: state
  }, children);
};

exports.ApiContextProvider = ApiContextProvider;